<template>
  <kst-page-list
    :catalog="SearchCatalog"
    :params="searchParams"
    :search="searchData"
    @init="handleInit"
    @load="handleLoad"
    @reset="handleReset"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        :paymentOptions="paymentOptions"
        :warehouseOptions="warehouseOptions"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data }">
      <List
        :access="access"
        :items="data.List"
      />
    </template>
  </kst-page-list>
</template>

<script>
import Model from "../DbpyModel.js";
import SearchCatalog from "./SearchCatalog.js";
import Services from "../../../services/Api/DebtPayServices.js";

import List from "./DbpyL_List.vue";
import Search from "./DbpyL_Search.vue";

export default {
  components: {
    List,
    Search
  },
  data: () => ({
    SearchCatalog: SearchCatalog,
    access: {},
    searchData: {
      Search: "",
      Date: null,
      PaymentTypeName: null,
      StatusID: null,
      VendorID: null,
      VendorName: "",
      WarehouseID: null
    },
    searchParams: ["Search", "Date", "PaymentTypeName", "StatusID", "VendorID",
      "VendorName", "WarehouseID"],
    paymentOptions: {},
    warehouseOptions: {}
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    handleInit(loadListData) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getListData(options); 
      loadListData(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      if (this.searchData.VendorID !== null) {
        this.searchData.VendorName = this.$kst.In.getString(
          data.Search.VendorName
        );
      }

      this.paymentOptions = Model.getPaymentOptions(data.PaymentTypeList,
        SearchCatalog.PaymentTypeName.Label
      );
      this.warehouseOptions = Model.getWarehouseOptions(
        data.WarehouseList, SearchCatalog.WarehouseID.Label
      );
    },

    handleLoad(loadList) {
      const options = this.getListOptions();
      const config = Services.getList(options);
      loadList(config);
    },
    handleReset() {
      this.resetSearch();
    },

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.paymentOptions = {};
      this.warehouseOptions = {};

      this.normalizeSearch();
    },
    normalizeSearch() {
      if (this.searchData.WarehouseID === null) {
        this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      }
    },
    resetSearch() {
      this.searchData.Search = "";
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.PaymentTypeName = this.$kst.Search.OptionAll;
      this.searchData.StatusID = this.$kst.Search.OptionAll;
      this.searchData.VendorID = null;
      this.searchData.VendorName = "";
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
    },
    getListOptions() {
      const paymentType =
        this.$kst.Search.getValue(this.searchData.PaymentTypeName, null) === null
        ? null
        : this.searchData.PaymentTypeName;
      const vendorId = this.$kst.Out.getInteger(this.searchData.VendorID);
      const vendorName = vendorId === null
        ? this.$kst.Out.getString(this.searchData.VendorName) : null;

      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        paymenttype: paymentType,
        status: this.$kst.Search.getValue(this.searchData.StatusID),
        vendor: vendorId,
        vendorname: vendorName,
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.List.Search.Fields
      };
    }
  }
}
</script>